export default __webpack_public_path__ + "static/media/Icons_8.dd4620c3.svg";